import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ListingClone from '../../../components/External/Listing/Clone'
import { checkPrivilege } from '../../../actions/serviceActions/common'
import { setI13nData } from '../../../actions/common'
import {
  fetchProposalSubStations,
  fetchProposals,
  createProposals
} from '../../../actions/serviceActions/proposal'

const mapStateToProps = (state) => ({
  proposal: state.proposal,
  page: state.page,
  flags: state.flags,
  env: state.page.env
})

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators(
    {
      fetchProposals,
      createProposals,
      setI13nData
    },
    dispatch
  )

  return {
    actions
  }
}

ListingClone.fetchData = async ({ store, req, res, match }) => {
  try {
    const tasks = [
      store.dispatch(checkPrivilege({ path: req.path })),
      store.dispatch(fetchProposalSubStations())
    ]
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ListingClone)

export default MappedContainer
